module.exports = __webpack_public_path__ + "static/img/vmarket_4th_front.885a256.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vmarket_4th_front.png
// module id = YrA6
// module chunks = 0